<script setup lang="ts">
import { useSecretCallNotice, closeSecretCallNotice } from '@/shared/calls/secretCallNotice'

const notice = useSecretCallNotice()
</script>

<template>
  <div
    v-if="notice.open"
    class="cSecretCallNotice"
    role="dialog"
    aria-modal="true"
    @keydown.esc="closeSecretCallNotice(false)"
  >
    <div class="cSecretCallNotice__box">
      <h2 class="cSecretCallNotice__title">
        🔒 {{ notice.title }}
      </h2>
      <p class="cSecretCallNotice__text">
        {{ notice.text }}
      </p>
      <div class="cSecretCallNotice__buttons">
        <button
          v-if="notice.cancelText"
          class="cSecretCallNotice__btn"
          @click="closeSecretCallNotice(false)"
        >
          {{ notice.cancelText }}
        </button>
        <button
          class="cSecretCallNotice__btn cSecretCallNotice__btn--primary"
          @click="closeSecretCallNotice(true)"
        >
          {{ notice.okText }}
        </button>
      </div>
    </div>
  </div>
</template>

<style>
/* Классы с уникальным префиксом: стили в проекте глобальные. */
.cSecretCallNotice {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
}
.cSecretCallNotice__box {
  width: 100%;
  max-width: 400px;
  padding: 24px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
}
.cSecretCallNotice__title {
  margin: 0 0 12px;
  font-family: var(--font-family-headers);
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-dark);
}
.cSecretCallNotice__text {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.45;
  color: var(--color-text-dark);
  opacity: 0.85;
}
.cSecretCallNotice__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.cSecretCallNotice__btn {
  padding: 10px 16px;
  border: 0;
  border-radius: 10px;
  background: var(--color-bg-gray);
  color: var(--color-text-dark);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.cSecretCallNotice__btn--primary {
  background: var(--color-primary);
  color: #fff;
}

/* Значок «Секретный звонок» на экранах звонка. */
.cSecretCallBadge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 0;
  border-radius: 999px;
  background: rgba(46, 160, 67, 0.9);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  cursor: pointer;
}
.cSecretCallBadge--pending {
  background: rgba(140, 151, 171, 0.9);
}
.cSecretCallBadge--floating {
  position: fixed;
  top: 16px;
  left: 50%;
  z-index: 1500;
  transform: translateX(-50%);
}
.cSecretCallBadge--plain {
  margin-top: 8px;
  cursor: default;
}
</style>
